import axios from "axios";
import configuration from "./config.json";
import Cookies from "universal-cookie";
import { version } from "react";
const cookies = new Cookies();

const hub_url = process.env.REACT_APP_HUB_URL;

const auth_url = process.env.REACT_APP_AUTH_URL;

var clientId = "servizi_sociali_matera";
var entityId = "8fefaafb-5a9f-44a6-b499-e4b56998eaf4";

// Funzione per convertire base64 in File
function base64ToFile(base64String, filename, mimeType) {
  const arr = base64String.split(",");
  const mime = mimeType || arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

const Repo = {
  convertiFormatoData: (data) => {
    if (!data) return "";
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
      const [giorno, mese, anno] = data.split("/");
      return `${anno}-${mese}-${giorno}`;
    }

    const dataObj = new Date(data);
    const anno = dataObj.getFullYear();
    const mese = ("0" + (dataObj.getMonth() + 1)).slice(-2);
    const giorno = ("0" + dataObj.getDate()).slice(-2);

    return `${anno}-${mese}-${giorno}`;
  },

  handleApiError: (error, setError) => {
    if (error.response && error.response.data) {
      if (error.response.data.errors) {
        const errors = error.response.data.errors;
        const errorMessages = Object.values(errors).flat().join(" ");
        setError(errorMessages || "Errore di validazione.");
        return;
      }
      if (error.response.data.title) {
        setError(error.response.data.title);
        return;
      }
      if (typeof error.response.data === "string") {
        setError(error.response.data);
        return;
      }
    }
    setError("Errore sconosciuto");
  },

  getListaServizi: (token, flag) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_LISTA_SERVIZI +
        "?idSettore=" +
        flag,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      params: {},
    }),

  getLabels: () => {
    var config = {
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_LABELS,
    };
    return axios(config);
  },

  getSubscriptionNewCount: (token) => {
    var config = {
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISCRIZIONI_NUOVE_CONTA,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return axios(config);
  },

  getSubscriptionNewList: (token) => {
    var config = {
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISCRIZIONI_NUOVE_RAGGRUPPATE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return axios(config);
  },

  getRefoundReceiptNewList: (token, id) =>
    axios({
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_GET_RIMBORSI_CARICATI_NUOVE}/${id}`,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  //lista-allegati-iscrizione/{subscriptionId}

  getRefoundReceiptNewListOperatore: (token, subscriptionId) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_RIMBORSI_CARICATI +
        "/" +
        subscriptionId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIseeList: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISEE_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIseeListUploaded: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISEE_LIST_UPLOADED,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIseeListValidated: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISEE_LIST_VALIDATED,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIseeFromInps: (token, userId, dataRicerca) =>
    axios({
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_GET_INPS}/${userId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
      params: dataRicerca ? { dataRicerca } : undefined,
    }),

  getIseeFromInpsDSU: (token, userId, protocolloDSU) =>
    axios({
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_GET_INPS_DSU}/${userId}/${protocolloDSU}`,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }),

  postValueIseeOCR: (token, id) =>
    axios({
      method: "post",
      url: hub_url + configuration.HUB_PATH_GET_VALUE_ISEE + "?id=" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getANPRIns: (token, cf) =>
    axios({
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_ANPR_INS}/${cf}`,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }),

  getFindUserAnpr: (token, cf) =>
    axios({
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_ANPR_FIND}/${cf}`,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }),

  getAnprLogs: (token, userId) =>
    axios({
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_ANPR_LOGS}/${userId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }),

  getIsee: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISEE + "?id=" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  deleteIsee: (token, id) =>
    axios({
      method: "delete",
      url: hub_url + configuration.HUB_PATH_POST_REMOVE_ISEE + "?id=" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getUserProfile: (token) =>
    axios({
      method: "GET",
      url:
        auth_url +
        configuration.AUTH_PATH_GET_PROFILE +
        "?clientId=" +
        clientId +
        "&entityId=" +
        entityId,
      headers: {
        "content-type": "application/octet-stream",
        "x-rapidapi-host": "example.com",
        Authorization: "Bearer " + token,
      },
      params: {},
    }),

  getServices: (token) => {
    var config = {
      method: "get",
      url: hub_url + configuration.HUB_PATH_GET_SERVICES_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  getUserServices: (token) => {
    var config = {
      method: "get",
      url: hub_url + configuration.HUB_PATH_GET_USER_SERVICES_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  getOneServices: (token, id) => {
    var config = {
      method: "get",
      url: hub_url + configuration.HUB_PATH_GET_ONE_SERVICE + "?id=" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getTypeService: (token, id) => {
    var config = {
      method: "get",
      url: hub_url + configuration.HUB_PATH_GET_TYPE_SERVICE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  postUpdateService: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPDATE_SERVICE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postInsertService: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_INSERT_SERVICES,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  deleteService: (token, id) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_DELETE_SERVICE + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  postSendIsee: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_SEND_ISEE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postSendSubscriptionFile: (token, obb) => {
    var config = {
      method: "post",
      url:
        hub_url + configuration.HUB_PATH_POST_UTENTE_ISCRIZIONE_CARICA_ALLEGATI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postSendSubscriptionFileOperator: (token, obb) => {
    var config = {
      method: "post",
      url:
        hub_url +
        configuration.HUB_PATH_POST_OPERATORE_ISCRIZIONE_CARICA_ALLEGATI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postSendIseeOperator: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_SEND_ISEE_OPERATOR,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postConfirmIsee: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_CONFIRM_ISEE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postUpdateRefund: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPDATE_STATE_REFUND,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  getUsersList: (token, obb) =>
    axios({
      method: "post",
      url: hub_url + configuration.HUB_PATH_GET_USERS_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: obb,
    }),

  postInsertUser: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_INSERT_USER,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postCSVImport: (token, obb, id) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_IMPORT_CSV + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  getUserOperator: (token, userId) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_USER_OPERATOR + "/" + userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getSubscriptionUser: (token, userId) =>
    axios({
      method: "GET",
      url:
        hub_url + configuration.HUB_PATH_GET_SUBSCRIPTION_USER + "/" + userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getSubscriptionFileUser: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_UTENTE_ISCRIZIONE_ALLEGATI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getSubscriptionFileOperator: (token, subId) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_OPERATORE_ISCRIZIONE_ALLEGATI +
        "/" +
        subId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  delEliminaAllegatoIscrizione: (token, id) =>
    axios({
      method: "DELETE",
      url:
        hub_url +
        configuration.HUB_PATH_DEL_UTENTE_ISCRIZIONE_ELIMINA_ALLEGATO +
        "/" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getPayment: (token, iuv, fiscalCode, referer) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_PAYMENT +
        iuv +
        (referer ? "?referer=" + window.location.href : "") +
        (fiscalCode ? "&fiscalcode=" + fiscalCode : ""),

      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postUpdateUser: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_UPDATE_USER,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postUpdatePosizioneDebitoria: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_UPDATE_PAGAMENTO,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postUpdateUserStatus: (token, userId) => {
    var config = {
      method: "post",
      url:
        hub_url + configuration.HUB_PATH_POST_USER_STATUS + "?userId=" + userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  poutUpdatePaidOp: (token, obj) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_GET_POST_PAYMENT_SUCCESS,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    return axios(config);
  },

  delPosizioneDebitoria: (token, pagamentoId, data) =>
    axios({
      method: "POST",
      url:
        hub_url +
        configuration.HUB_PATH_OP_DEL_POSIZIONE_DEBITORIA +
        pagamentoId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: data,
      params: {},
    }),

  postDeleteUser: (token, userId) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_DELETE_USER + "/" + userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getUserInfo: async (token) =>
    await axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_USER_INFO,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getExecInfo: async (token) =>
    await axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_EXECUTIVES_INFO,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getUsersLoadedCount: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_USER_STATUS_COUNT_LOADED,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getRangesList: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_RANGES_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postDeleteRange: (token, rangeId) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_DELETE_RANGE + "?id=" + rangeId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  postDeleteAllegato: (token, id) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_ALLGATO_DELETE + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  postUpdCartellaSociale: (token, userId, obj) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_UPD_CARTELLASOCIALE + "/" + userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    return axios(config);
  },

  postInsertRange: (token, obj) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_INSERT_RANGE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    return axios(config);
  },

  getRangeById: (token, rangeId) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_RANGE + "?id=" + rangeId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getSubscriptionById: (token, subscriptionId) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_SUBSCRIPTION +
        "/" +
        subscriptionId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postUpdateRange: (token, obj) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPDATE_RANGE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    return axios(config);
  },

  getConfiguration: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_CONFIGURATION,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postUpdateConfiguration: (token, obj) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPDATE_CONFIGURATION,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    return axios(config);
  },

  getSelectVersioneServizio: (token) => {
    var config = {
      method: "get",
      url: hub_url + configuration.HUB_PATH_SELECT_VERSIONE_SERVIZIO,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getAnnouncementsByService: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url + configuration.HUB_PATH_GET_ANNOUNCEMENT_BY_SERVICE + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getAllegatiUtente: (token, fiscalcode) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_LISTA_ALLGATI_UTENTE +
        "/" +
        fiscalcode,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getAllegatiEntity: (token, tipoEntity, entityId) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_LISTA_ALLGATI +
        "/" +
        tipoEntity +
        "/" +
        entityId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getFileAllegato: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_ALLGATO_DOWNLOAD + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  //HUB_PATH_GET_OPERATORE_ISCRIZIONE_ALLEGATO
  getFileAllegatoIscrizione: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_OPERATORE_ISCRIZIONE_ALLEGATO +
        "/" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  ///////
  postInsertAllegato: (token, tipoEntity, entityId, descrizione, file) => {
    const data2 = new FormData();
    data2.append("EntityId", entityId);
    data2.append("EntityType", tipoEntity);
    data2.append("Nome", "");
    data2.append("Descrizione", descrizione);
    data2.append("File", file);

    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_ALLGATO_UPLOAD,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
      data: data2,
    };
    return axios(config);
  },

  //HUB_PATH_ALLGATO_UPLOAD

  generateCsv: (token, id, data) =>
    axios({
      responseType: "arraybuffer",
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_POST_GENERATE_CSV +
        "/" +
        id +
        "?mounth=" +
        data.mese +
        "&year=" +
        data.anno,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "text/csv",
      },
      responseType: "blob",
    }),

  sendMyPay: (
    token,
    id,
    data,
    fiscalcode,
    costoPersonalizzato,
    nuovaDescrizione,
    filters = {},
  ) => {
    const monthFromPayload =
      typeof data === "object"
        ? parseInt(data?.mese ?? data?.month, 10)
        : parseInt(data, 10);
    const baseYear =
      typeof data === "object"
        ? Number(data?.anno) || new Date().getFullYear()
        : new Date().getFullYear();

    const safeMonth = Number.isNaN(monthFromPayload)
      ? new Date().getMonth() + 1
      : monthFromPayload;
    const normalizedMonth = safeMonth > 12 ? safeMonth - 12 : safeMonth;
    const normalizedYear = safeMonth > 12 ? baseYear + 1 : baseYear;
    const monthString = String(normalizedMonth).padStart(2, "0");
    const referenceDate =
      typeof data === "object" && data?.data
        ? data.data
        : `${monthString}/${normalizedYear}`;

    const fiscalCodeFilter = filters?.fiscalCode ?? "";
    const nProtocolloFilter = filters?.nProtocollo ?? "";
    const stateFilter = filters?.confirmed ?? "";

    return axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_POST_SEND_MYPAY +
        "/" +
        id +
        "?mounth=" +
        monthString +
        "&year=" +
        normalizedYear +
        "&date=" +
        encodeURIComponent(referenceDate) +
        "&fiscalcode=" +
        (fiscalcode ?? fiscalCodeFilter ?? "") +
        "&nProtocollo=" +
        encodeURIComponent(nProtocolloFilter) +
        "&state=" +
        encodeURIComponent(stateFilter) +
        "&costoPersonalizzato=" +
        (costoPersonalizzato ?? "") +
        "&nuovaDescrizione=" +
        (nuovaDescrizione ?? ""),
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  getAnnouncementsByServiceOperator2: async (token, id) => {
    try {
      const url =
        id != null
          ? hub_url +
            configuration.HUB_PATH_GET_ANNOUNCEMENT_BY_SERVICE_OPERATOR +
            "/" +
            id
          : hub_url +
            configuration.HUB_PATH_GET_ANNOUNCEMENT_BY_SERVICE_OPERATOR;

      const response = await axios({
        method: "GET",
        url,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      // Restituisci i dati di risposta
      return response;
    } catch (error) {
      // Gestisci gli errori
      console.error("Errore durante la richiesta:", error);
      throw error;
    }
  },

  getAnnouncementsByServiceOperator: async (token, serviceId) =>
    await axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_ANNOUNCEMENT_BY_SERVICE_OPERATOR +
        "/" +
        serviceId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getAnnouncementsByServiceOperatorNotUsed: (token, userId) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_ANNOUNCEMENT_BY_SERVICE_OPERATOR_NOT_SUBSCRIPTION +
        "/" +
        userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getPagamentiUtenti: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_USER_PAYMENT,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getPagamentiUtentiOperator: (token, fiscalCode) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_USER_PAYMENT_OPERETOR +
        "?fiscalcode=" +
        fiscalCode,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getAnnouncementsOperator: (token) =>
    axios({
      method: "GET",
      url:
        hub_url + configuration.HUB_PATH_GET_ANNOUNCEMENT_BY_SERVICE_OPERATOR,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postUser: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_USER,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postEmail: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_EMAIL,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postInsertSession: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_INSERT_SESSION,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postUpdateSession: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPDATE_SESSION,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  deleteSession: (token, id) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_DELETE_SESSION + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getUser: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_USER,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getSessionById: (token, sessionId) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_SESSION_BY_ID + sessionId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getSessionByIdUser: (token, sessionId) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_SESSION_BY_ID_USER + sessionId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getGeneralId: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_GENERAL_ID_SUBSCRIPTION,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),
  postSubscribeUserFromOperator: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_SUBSCRIBE_USER_FROM_OPERATOR,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postMedicoCurante: (token, cartellaId, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_MEDICO_CURANTE + cartellaId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: { stringa: data },
    };
    return axios(config);
  },

  postInsertHours: (token, subId, ore) => {
    var config = {
      method: "post",
      url:
        hub_url + configuration.HUB_PATH_POST_INSERT_HOURS + subId + "/" + ore,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  postInsertScore: (token, subId, score) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_INSERT_SCORE + subId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: { stringa: score },
    };
    return axios(config);
  },

  postConfirmUser: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_CONFIRM_DENY_SUBSCRIPTION,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postModifyHours: (token, id, mese, ore) => {
    var config = {
      method: "post",
      url:
        hub_url +
        configuration.HUB_PATH_POST_MODIFY_HOURS +
        id +
        "/" +
        mese +
        "/" +
        ore,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  postUnsubscribeUser: (token, id, userId) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UNSUBSCRIBE + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getListaServizi: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_LISTA_SERVIZI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIscrizioni: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISCRIZIONI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  postSubscriptionUser: (token, data) =>
    axios({
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_ISCRIZIONE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: data,
    }),

  generateCoupons: (token, data) =>
    axios({
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_GENERATE_COUPONS,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: data,
    }),

  postUpdateRanking: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPDATE_RANKING,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  getAnnouncementsBacheca: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ANNOUNCEMENT_BACHECA,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getListSubscription: (token, id) =>
    axios({
      responseType: "arraybuffer",
      method: "GET",
      url: hub_url + configuration.HUB_PATH_POST_EXPORT_SUBSCRIPTION + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "text/csv",
      },
      responseType: "blob",
    }),

  downloadFileOperator: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_DOWNLOAD_FILE_OPERATOR + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  downloadCsvOperator: (token, id, filters) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_DOWNLOAD_CSV_OPERATOR + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      responseType: "text",
      params: {
        ...(filters.fiscalCode && { fiscalCode: filters.fiscalCode }),
        ...(filters.nProtocollo && { nProtocollo: filters.nProtocollo }),
        ...(filters.confirmed && { state: filters.confirmed }),
        ...(filters.city && { city: filters.city }),
        ...(filters.descrizione && {
          descrizioneIstanze: filters.descrizione,
        }),
      },
    }),

  downloadFileUser: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_DOWNLOAD_FILE_USER + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  downloadGraduatoria2: async (token, id, sovrescrivi) =>
    await axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GRADUATORIA_DOWNLOAD +
        "/" +
        id +
        "/" +
        sovrescrivi,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  downloadGraduatoria: async (token, id, sovrescrivi) => {
    try {
      const response = await axios({
        method: "GET",
        url: `${hub_url}${configuration.HUB_PATH_GRADUATORIA_DOWNLOAD}/${id}/${sovrescrivi}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        responseType: "blob", // Indica ad Axios di trattare la risposta come un blob
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      let fileName = "downloaded_file.xlsx";

      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*=UTF-8''(.+)$/);
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        } else {
          const matchSimple = contentDisposition.match(/filename="(.+?)"/);
          if (matchSimple && matchSimple[1]) {
            fileName = matchSimple[1];
          }
        }
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Download error:", error);
    }
  },

  ValidateCSVByToken: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_VALIDATE_CSV_BY_TOKEN + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getListPaymentOperator: (token, id, fiscalCode) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_LISTA_PAGAMENTI_OPERATOR +
        "?" +
        (id
          ? "subscriptionId=" +
            id +
            "&" +
            (fiscalCode ? "fiscalcode=" + fiscalCode : "")
          : fiscalCode
            ? "fiscalcode=" + fiscalCode
            : ""),
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getListPaymentFilterOperator: (token, data) =>
    axios({
      method: "POST",
      url: hub_url + configuration.HUB_PATH_GET_LISTA_PAGAMENTI_FILTRO_OPERATOR,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: data,
    }),

  getListPaymentUser: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_LISTA_PAGAMENTI_USER +
        "?subscriptionId=" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIuvUser: (token, id, bool) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_IUV_FILE_USER +
        "/" +
        id +
        "/" +
        bool,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIuvOperator: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_IUV_FILE_OPERATOR +
        "/" +
        id +
        "/" +
        bool,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  postListFlows: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_LIST_FLOWS,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  deleteFileOperator: (token, id) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_DELETE_FILE + "?id=" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getRendicontazione: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_RENDICONTAZIONE +
        "?annuncementId=" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  GetAnamnesiFamiliariByAssistitoIdAsync: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_ANAMNESI_FAMILIARI_BYASSISTITOID_ASYNC +
        "/" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  GetComponentiNucleoFamiliareByAssistitoIdAsync: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_COMPONENTI_NUCLEO_FAMILIARE_BYASSISTITOID_ASYNC +
        "/" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  GetCondizioniAbitativeByAssistitoIdAsync: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_CONDIZIONI_ABITATIVE_BYASSISTITOID_ASYNC +
        "/" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  GetInterventiSocioAssistenzialiByAssistitoIdAsync: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_INTERVENTI_SOCIOASSISTENZIALI_BYASSISTITOID_ASYNC +
        "/" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  GetAnamnesiFamiliareById: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url + configuration.HUB_PATH_GET_ANAMNESI_FAMILIARE_BYID + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  GetComponenteNucleoFamiliareById: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_COMPONENTE_NUCLEOFAMILIARE_BYID +
        "/" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  GetCondizioneAbitativeById: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_CONDIZIONE_ABITATIVE_BYID +
        "/" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  GetInterventoSocioAssistenzialeById: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_INTERVENTO_SOCIOASSISTENZIALE_BYID +
        "/" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  GetCartellaSocialeByUserId: (token, id) => {
    const url =
      hub_url + configuration.HUB_PATH_GET_CARTELLASOCIALE_BYUSERID + "/" + id;
    return axios({
      method: "GET",
      url: url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    });
  },

  DelAnamnesiFamiliare: (token, id) => {
    var config = {
      method: "DELETE",
      url: `${hub_url}${configuration.HUB_PATH_DEL_ANAMNESI_FAMILIARE}/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  DelComponenteNucleoFamiliare: (token, id) => {
    var config = {
      method: "DELETE",
      url: `${hub_url}${configuration.HUB_PATH_DEL_COMPONENTE_NUCLEO_FAMILIARE}/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  DelCondizioneAbitative: (token, id) => {
    var config = {
      method: "DELETE",
      url: `${hub_url}${configuration.HUB_PATH_DEL_CONDIZIONI_ABITATIVE}/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  DelInterventoSocioAssistenziale: (token, id) => {
    var config = {
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_DEL_INTERVENTO_SOCIO_ASSISTENZIALE}/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  DelAssistito: (token, id) => {
    var config = {
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_DEL_ASSISTITO}/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  UpdAnamnesiFamiliare: (token, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_UPD_ANAMNESI_FAMILIARE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  UpdComponenteNucleoFamiliare: (token, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_UPD_COMPONENTE_NUCLEO_FAMILIARE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  UpdCondizioneAbitative: (token, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_UPD_CONDIZIONE_ABITATIVE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  UpdInterventoSocioAssistenziale: (token, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_UPD_INTERVENTO_SOCIO_ASSISTENZIALE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  UpdAssistito: (token, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_UPD_ASSISTITO}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },
  // -------------------------------------------  //

  AddAssistito: (token, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_ADD_ASSISTITO}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  /*ComponenteNucleoFamiliare: (token, nucleo, azione, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_COMPONENTE_NUCLEO_FAMILIARE}/${nucleo}/${azione}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },*/

  ComponenteNucleoFamiliare: (
    token,
    nucleo,
    azione,
    nucleoFamiliareId,
    obb,
  ) => {
    try {
      let method;
      let url;

      switch (azione.toLowerCase()) {
        case "aggiungi":
          method = "post";
          url = `${hub_url}${configuration.HUB_PATH_COMPONENTE_NUCLEO_FAMILIARE}/${nucleo}/${azione}`;
          break;

        case "aggiorna":
          method = "post";
          url = `${hub_url}${configuration.HUB_PATH_COMPONENTE_NUCLEO_FAMILIARE}/${nucleo}/${azione}`;
          break;

        case "elimina":
          method = "delete";
          url = `${hub_url}${configuration.HUB_PATH_COMPONENTE_NUCLEO_FAMILIARE}/${nucleo}/${azione}/${nucleoFamiliareId}`;
          break;
        case "visualizza":
          method = "get";
          url = `${hub_url}${configuration.HUB_PATH_COMPONENTE_NUCLEO_FAMILIARE}/${nucleo}/${nucleoFamiliareId}`;
          break;

        default:
          throw new Error("Azione non supportata");
      }

      const config = {
        method,
        url,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: obb, // Aggiungi l'oggetto nei dati della richiesta
      };

      const response = axios(config);

      // Puoi fare qualcosa con la risposta se necessario
      // Ad esempio, restituire solo i dati:
      return response;
    } catch (error) {
      // Gestione degli errori
      console.error("Si è verificato un errore durante la richiesta:", error);
      throw error; // Rilancia l'errore per gestirlo più a monte, se necessario
    }
  },

  AddCondizioneAbitative: (token, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_ADD_CONDIZIONE_ABITATIVE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },
  AddInterventoSocioAssistenziale: (token, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_ADD_INTERVENTO_SOCIOASSISTENZIALE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },
  AddAnamnesiFamiliare: (token, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_ADD_ANAMNESI_FAMILIARE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  AddDiarioDiBordo: (token, cartellaSocialeId, descrizione) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_ADD_DIARIO_DI_BORDO}${cartellaSocialeId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        string: descrizione,
      },
    };

    return axios(config);
  },

  UpdDiarioDiBordo: (token, cartellaSocialeId, descrizione) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_UPD_DIARIO_DI_BORDO}${cartellaSocialeId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        string: descrizione,
      },
    };

    return axios(config);
  },

  DelDiarioDiBordo: (token, cartellaSocialeId) => {
    var config = {
      method: "DELETE",
      url: `${hub_url}${configuration.HUB_PATH_DEL_DIARIO_DI_BORDO}${cartellaSocialeId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },
  /*coupon */
  AddCoupon: (token, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_POST_ADD_COUPON}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  UpdCoupon: (token, obb) => {
    var config = {
      method: "post",
      url: `${hub_url}${configuration.HUB_PATH_POST_UPD_COUPON}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },
  DelCoupon: (token, id) => {
    var config = {
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_DEL_ASSISTITO}/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  GetCouponsByCF: (token, fiscalCode) => {
    const url = hub_url + configuration.HUB_PATH_GET_LIST_COUPON;
    return axios({
      method: "GET",
      url: url, // Usa l'URL appena creato
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: { fiscalCode },
    });
  },

  UseCoupon: (token, id) => {
    const url = hub_url + configuration.HUB_PATH_GET_USE_COUPON + "/" + id;
    return axios({
      method: "GET",
      url: url, // Usa l'URL appena creato
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    });
  },

  ViewCoupon: (token, id) => {
    const url = hub_url + configuration.HUB_PATH_GET_VIEW_COUPON + "/" + id;
    return axios({
      method: "GET",
      url: url, // Usa l'URL appena creato
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    });
  },

  ListCoupon: (token) => {
    const url = hub_url + configuration.HUB_PATH_GET_LIST_COUPON;
    return axios({
      method: "GET",
      url: url, // Usa l'URL appena creato
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    });
  },
  ListCouponsUsed: (token, idExecutive) => {
    const url =
      hub_url +
      configuration.HUB_PATH_GET_LIST_COUPON_USED +
      "?inputExecId=" +
      idExecutive;
    return axios({
      method: "GET",
      url: url, // Usa l'URL appena creato
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    });
  },

  UrlCoupon: (id) => {
    const url = hub_url + configuration.HUB_PATH_GET_VIEW_COUPON + "/" + id;
    return url;
  },

  UrlCoupon: () => {
    const url = hub_url + configuration.HUB_PATH_GET_VIEW_COUPON + "/";
    return url;
  },

  UrlCoupon2: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_DOWNLOAD_COUPON + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  SendEmailCoupon: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_SEND_EMAIL_COUPON + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  ExecutivesSelectList: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_EXECUTIVES_SELECT_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  SubscriptionsSelectList: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_USER_SUBSCRIPTION_SELECT_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  GetPresenzeList: (token, subId, annId) => {
    let url;

    if (annId) {
      url = hub_url + configuration.HUB_PATH_GET_PRESENZE_ANN + `/${annId}`;
    } else if (subId) {
      url = hub_url + configuration.HUB_PATH_GET_PRESENZE_SUB + `/${subId}`;
    } else {
      // Gestione caso in cui entrambi sono nulli o undefined
      // Decide cosa fare in base ai tuoi requisiti
    }
    return axios({
      method: "GET",
      url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  UpdPresenze: (token, obb, subId) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_PRESENZA + `/${subId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  GetBudget: (token, userId) =>
    axios({
      method: "GET",
      url: userId
        ? `${hub_url}${configuration.HUB_PATH_BUDGET}/${userId}`
        : `${hub_url}${configuration.HUB_PATH_BUDGET}`,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  GetGPresenze: (token, userId, annuncementId) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GPRESENZE +
        `?userId=${userId}` +
        `&annuncementId=${annuncementId}`,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postExecutiveInfo: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_EXECUTIVES_POST_INFO_BY_TOKEN,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  getExecutiveInfo: (token) => {
    var config = {
      method: "GET",
      url: hub_url + configuration.HUB_PATH_EXECUTIVES_GET_INFO_BY_TOKEN,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getExecutiveAllServices: (token) => {
    var config = {
      method: "GET",
      url: hub_url + configuration.HUB_PATH_EXECUTIVES_SELECT_SERVICE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  getListaInterventi: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_OPERATOR_SELECT_ANNOUNCEMENTS,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getExecutiveStatistics: (token, from, to) => {
    var url = hub_url + configuration.HUB_PATH_EXECUTIVES_STATISTICS_COUPON;

    if ((from && from.trim() !== "") || (to && to.trim() !== "")) {
      url = hub_url + configuration.HUB_PATH_EXECUTIVES_STATISTICS_COUPON + "/";

      if (from) {
        url += "?from=" + from;
      }

      if (to) {
        url += "?to=" + to;
      }
    }

    if (from && from.trim() !== "" && to && to.trim() !== "") {
      url = hub_url + configuration.HUB_PATH_EXECUTIVES_STATISTICS_COUPON + "/";

      url += "?from=" + from + "&to=" + to;
    }

    var config = {
      method: "GET",
      url: url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getExecutiveStatisticsByOperator: (token, id, from, to) => {
    var url =
      hub_url +
      configuration.HUB_PATH_OPERATOR_STATISTICS_EXECUTIVE_COUPON +
      "/" +
      id;

    if ((from && from.trim() !== "") || (to && to.trim() !== "")) {
      url =
        hub_url +
        configuration.HUB_PATH_OPERATOR_STATISTICS_EXECUTIVE_COUPON +
        "/" +
        id;

      if (from) {
        url += "?from=" + from;
      }

      if (to) {
        url += "?to=" + to;
      }
    }

    if (from && from.trim() !== "" && to && to.trim() !== "") {
      url =
        hub_url +
        configuration.HUB_PATH_OPERATOR_STATISTICS_EXECUTIVE_COUPON +
        "/" +
        id;

      url += "?from=" + from + "&to=" + to;
    }

    var config = {
      method: "GET",
      url: url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return axios(config);
  },

  getExecutiveIdByOperator: (token, executiveId) => {
    return axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_OPERATOR_GET_EXECUTIVE_ID +
        "/" +
        executiveId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  addNewExecutiveInfoByOperator: (token, dataExecutive) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_OPERATOR_POST_EXECUTIVE_ID,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: dataExecutive,
    };

    return axios(config);
  },

  postExecutiveInfoByOperator: (token, executiveId, dataExecutive) => {
    var config = {
      method: "post",
      url:
        hub_url +
        configuration.HUB_PATH_OPERATOR_POST_EXECUTIVE_ID +
        "/" +
        executiveId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: dataExecutive,
    };

    return axios(config);
  },

  postExecutiveEnableByOperator: (token, executiveId, enable) => {
    var config = {
      method: "post",
      url:
        hub_url +
        configuration.HUB_PATH_OPERATOR_POST_EXECUTIVE_ENABLE +
        "/" +
        executiveId +
        "/" +
        enable,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  getExecutiveListByOperator: (token) => {
    return axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_OPERATOR_GET_EXECUTIVE_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  searchExecutiveByOperator: (token, dataExecutive) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_OPERATOR_SEARCH_EXECUTIVE_DATA,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: dataExecutive,
    };

    return axios(config);
  },

  deleteExecutiveIdByOperator: (token, executiveId) => {
    var config = {
      method: "DELETE",
      url:
        hub_url +
        configuration.HUB_PATH_OPERATOR_DELETE_EXECUTIVE_ID +
        "/" +
        executiveId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  //Fondi
  updateFondoOperator: (token, fondo) => {
    var config = {
      method: "put",
      url: hub_url + configuration.HUB_PATH_PUT_OPERATORE_FONDO_AGGIORNA,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: fondo,
    };

    return axios(config);
  },

  spostaFondi: (token, reqSposta) => {
    var config = {
      method: "POST",
      url: hub_url + configuration.HUB_PATH_GET_OPERATOR_SPOSTA,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: reqSposta,
    };

    return axios(config);
  },

  deleteFondoOperator: (token, fondoId) => {
    var config = {
      method: "DELETE",
      url:
        hub_url +
        configuration.HUB_PATH_DEL_OPERATORE_FONDO_ELIMINA +
        "/" +
        fondoId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  freezeFondoOperator: (token, articolo, capitolo) => {
    var config = {
      method: "post",
      url:
        hub_url +
        configuration.HUB_PATH_POST_OPERATORE_FONDO_FREEZE +
        "?articolo=" +
        articolo +
        "&capitolo=" +
        capitolo,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  aggiornaFondoOperator: (token, articolo, capitolo) => {
    var config = {
      method: "post",
      url:
        hub_url +
        configuration.HUB_PATH_POST_OPERATORE_FONDO_AGGIORNA +
        "?articolo=" +
        articolo +
        "&capitolo=" +
        capitolo,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getFondiListaOperator: (token, articolo = null, capitolo = null) => {
    let url = hub_url + configuration.HUB_PATH_GET_OPERATORE_FONDO_LISTA;
    let queryParams = "";

    if (articolo !== null) {
      queryParams += `?articolo=${articolo}`;
    }
    if (capitolo !== null) {
      queryParams += `${queryParams === "" ? "?" : "&"}capitolo=${capitolo}`;
    }

    return axios({
      method: "GET",
      url: url + queryParams,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  getFondiStoricoListaOperator: (token, fondoId) => {
    let url =
      hub_url +
      configuration.HUB_PATH_GET_OPERATORE_FONDO_LISTA_STORICO +
      "/" +
      fondoId;

    return axios({
      method: "GET",
      url: url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  getFondiSelectOperator: (token, fondoId) => {
    let url =
      hub_url +
      configuration.HUB_PATH_GET_OPERATOR_SELECT_FONDO +
      "/" +
      fondoId;

    return axios({
      method: "GET",
      url: url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  addFondoOperator: (token, fondo) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_OPERATORE_FONDO_AGGIUNGI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: fondo,
    };

    return axios(config);
  },

  getFondoOperator: (token, fondoId) => {
    return axios({
      method: "GET",
      url:
        hub_url + configuration.HUB_PATH_POST_OPERATORE_FONDO + "/" + fondoId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  getAnagraficaInserisci: (token, codicefiscale) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_ADD_UTENTE_ANAGRAFICA +
        "/" +
        codicefiscale,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getAnagraficaCerca: (token, codicefiscale) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_CERCA_UTENTE_ANAGRAFICA +
        "/" +
        codicefiscale,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  creaDocumentoCartellaSociale: (token, id) => {
    var config = {
      method: "get",
      url:
        hub_url +
        configuration.HUB_PATH_GET_CREA_DOCUMENTO_CARTELLA_SOCIALE +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  postInsertAttoFirmato: (token, entityId, file, fileName, description) => {
    const data2 = new FormData();
    data2.append("EntityId", entityId);
    data2.append("EntityType", "");
    data2.append("Nome", fileName + "_" + entityId + ".pdf");
    data2.append("Descrizione", description);
    data2.append("File", file);

    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_ATTO_FIRMATO,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
      data: data2,
    };
    return axios(config);
  },
  getTotali: (token) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_TOTALI +
        "/2025-01-01T00%3A00%3A00",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getImportStato: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_IMPORT_STATUS,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  startPnrrSynchronization: (token, announcementId) =>
    axios({
      method: "POST",
      url: hub_url + configuration.HUB_PATH_POST_PNRR_SYNC,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: JSON.stringify({ announcementId: announcementId ?? null }),
    }),

  getPnrrSynchronizationStatus: (token, announcementId) =>
    axios({
      method: "GET",
      url:
        hub_url + configuration.HUB_PATH_GET_PNRR_SYNC_STATUS + announcementId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postRiceviPosizioniDebitorie: (token) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_ALL_EXPORT,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  getAllComuni: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ALL_COMUNI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getAllComuniEx: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ALL_COMUNI_EX,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getUsersListEx: (token, obb) =>
    axios({
      method: "post",
      url: hub_url + configuration.HUB_PATH_GET_USERS_LIST_EX,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: obb,
    }),

  postInsertDettaglio: (token, azione, obb) =>
    axios({
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_INSERT_DETTAGLIO + azione,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: obb,
    }),

  haveUserIsee: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_HAVE_USER_ISEE + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),
  getIseeFromInps: (token, userId, dataRicerca) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_ISEE_FROM_INPS +
        userId +
        (dataRicerca ? "?dataRicerca=" + dataRicerca : ""),
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  postSendIO: (token, iuv, userId) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_RESEND_IO + iuv + "/" + userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  postSendEmail: (token, iuv, userId) => {
    var config = {
      method: "post",
      url:
        hub_url +
        configuration.HUB_PATH_POST_PAYMENT_SEND_EMAIL +
        "/" +
        iuv +
        "/" +
        userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  downloadPreview: (token, id, mese, filters = {}) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_DOWNLOAD_CSV_PREVIEW_PAYMENT +
        id +
        "/" +
        mese,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {
        ...(filters.fiscalCode && { fiscalCode: filters.fiscalCode }),
        ...(filters.nProtocollo && { nProtocollo: filters.nProtocollo }),
        ...(filters.confirmed && { state: filters.confirmed }),
      },
    }),

  downloadPreviewNotify: (token, id, mese, filters = {}) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_DOWNLOAD_CSV_PREVIEW_NOTIFICATION +
        id +
        "/" +
        mese,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {
        ...(filters.fiscalCode && { fiscalCode: filters.fiscalCode }),
        ...(filters.nProtocollo && { nProtocollo: filters.nProtocollo }),
        ...(filters.confirmed && { state: filters.confirmed }),
      },
    }),

  notifyAll: (token, id, mese, tipoNotifica, filters = {}) =>
    axios({
      method: "POST",
      url:
        hub_url +
        configuration.HUB_PATH_POST_SEND_NOTIFY_ALL +
        id +
        "/" +
        mese +
        "/" +
        tipoNotifica,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {
        ...(filters.fiscalCode && { fiscalCode: filters.fiscalCode }),
        ...(filters.nProtocollo && { nProtocollo: filters.nProtocollo }),
        ...(filters.confirmed && { state: filters.confirmed }),
      },
    }),

  getPaymentFile: (token, id, mese) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_PAYMENT_FILE + id + "/" + mese,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  // Aggiornamento Massivo
  avviaCodaAnpr: (token, limit) =>
    axios({
      method: "post",
      url: hub_url + configuration.HUB_PATH_AGG_MASSIVO_CODA_ANPR,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: limit ? { limit } : {},
    }),

  avviaCodaInps: (token, limit) =>
    axios({
      method: "post",
      url: hub_url + configuration.HUB_PATH_AGG_MASSIVO_CODA_INPS,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: limit ? { limit } : {},
    }),

  getUtentiPerAnagrafica: (token, page, pageSize) =>
    axios({
      method: "get",
      url: hub_url + configuration.HUB_PATH_AGG_MASSIVO_UTENTI_ANAGRAFICA,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: { page: page || 1, pageSize: pageSize || 50 },
    }),

  getUtentiPerIsee: (token, page, pageSize) =>
    axios({
      method: "get",
      url: hub_url + configuration.HUB_PATH_AGG_MASSIVO_UTENTI_ISEE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: { page: page || 1, pageSize: pageSize || 50 },
    }),

  getStatoCodaAggiornamento: (token) =>
    axios({
      method: "get",
      url: hub_url + configuration.HUB_PATH_AGG_MASSIVO_STATO_CODA,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getChangelogAggiornamento: (token, tipo, page, pageSize, soloErrori) =>
    axios({
      method: "get",
      url: hub_url + configuration.HUB_PATH_AGG_MASSIVO_CHANGELOG,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {
        ...(tipo !== undefined && tipo !== null ? { tipo } : {}),
        ...(soloErrori ? { soloErrori: true } : {}),
        page: page || 1,
        pageSize: pageSize || 50,
      },
    }),

  postAddScuolaVersione: (token, versioneId, nomeVersione) => {
    const data2 = new FormData();
    data2.append("nomeVersione", nomeVersione);
    if (
      versioneId &&
      versioneId !== "" &&
      versioneId !== "null" &&
      versioneId !== "undefined" &&
      versioneId !== null &&
      versioneId !== undefined
    ) {
      data2.append("versioneId", versioneId);
    }

    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_SCUOLA_VERSIONE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
      data: data2,
    };
    return axios(config);
  },

  postUploadAlunni: (token, versioneId, fileOrBase64) => {
    let file = fileOrBase64;
    if (typeof fileOrBase64 === "string" && fileOrBase64.startsWith("data:")) {
      file = base64ToFile(fileOrBase64, "alunni.csv", "text/csv");
    }
    const data2 = new FormData();
    data2.append("file", file);
    data2.append("versioneId", versioneId);

    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPLOAD_ALUNNI,
      headers: {
        Authorization: "Bearer " + token,
      },
      data: data2,
    };
    return axios(config);
  },

  delScuolaVersione: (token, versioneId) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_DEL_SCUOLA_VERSIONE + versioneId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
    };
    return axios(config);
  },

  getScuolaVersioni: (token) => {
    var config = {
      method: "get",
      url: hub_url + configuration.HUB_PATH_GET_SCUOLA_VERSIONE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
    };
    return axios(config);
  },

  getScuolaVersioneIscrizioni: (token, versioneId) => {
    var config = {
      method: "get",
      url:
        hub_url +
        configuration.HUB_PATH_GET_SCUOLA_VERSIONE_ISCRIZIONI +
        versioneId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
    };
    return axios(config);
  },

  getListaAnnouncementMensaOp: (token, id, mese) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_DOWNLOAD_CSV_PREVIEW_NOTIFICATION +
        id +
        "/" +
        mese,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  postPresenzeMensa: (token, versioneId, minorePresenzeIds, dataPresenza) => {
    // Assicurati che minorePresenzeIds sia un array
    let idsArray = Array.isArray(minorePresenzeIds)
      ? minorePresenzeIds
      : minorePresenzeIds.split(",").map((id) => id.trim());

    const requestData = {
      dataPresenza: dataPresenza,
      minorePresenzeIds: idsArray ?? [],
    };

    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_PRESENZE_MENSA + versioneId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: requestData,
    };
    return axios(config);
  },

  getListaScuole: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_LISTA_SCUOLE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getListaScuoleOperatori: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_LISTA_SCUOLE_OPERATORI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  postOrUpdateScuolaOperatori: (token, data) =>
    axios({
      method: "POST",
      url: hub_url + configuration.HUB_PATH_POST_SCUOLA_OPERATORI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
      data: data,
    }),

  delResponsabileScuola: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_DEL_SCUOLA_OPERATORI + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),
};

export default Repo;
